module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "createNoteForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNote($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "noteTitle",
    attrs: {
      "type": "text",
      "name": "title",
      "placeholder": "Title",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    ref: "textArea",
    staticClass: "noteBody",
    attrs: {
      "name": "body",
      "placeholder": "Take a note...",
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-color-text--grey-800",
    attrs: {
      "id": "submitButton"
    }
  }, [_vm._v("Done")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12cd6a1c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/NoteForm.vue
// module id = 17
// module chunks = 0